var map = {
	"./3cx_flag.png": "a61d",
	"./8x8.png": "9d6b",
	"./UC_Banner_Powered.png": "9fc8",
	"./alcatel_flag.png": "0738",
	"./asterisk_flag.png": "08e8",
	"./avaya_flag.png": "5d91",
	"./blank_flag.png": "c32a",
	"./bt.png": "e58a",
	"./cisco.png": "bd4e",
	"./cisco_flag.png": "4682",
	"./download.png": "4d80",
	"./excel.png": "c374",
	"./favicon.png": "c752",
	"./globe_flag.png": "eb6a",
	"./green.png": "de8d",
	"./microsoft_flag.png": "a528",
	"./mit.png": "7c48",
	"./mit_zt.png": "ad74",
	"./mitel.png": "657a",
	"./mitel_flag.png": "658c",
	"./mitel_sm.png": "8272",
	"./nec_flag.png": "1c0c",
	"./philips_flag.png": "8646",
	"./pleasewait.png": "a7f9",
	"./rc_flag.png": "3bc8",
	"./ringcentral.png": "135d",
	"./sopho_flag.png": "1934",
	"./ucentric.png": "54eb",
	"./unify_flag.png": "5874",
	"./viegli.png": "0004",
	"./word.png": "93bf",
	"./zoom_flag.png": "f4ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e3a8";